import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../lib/loopback'

const gestoresCentroCustoRepository = createRepository({
  path: 'gestores-centro-custo',
  parentPath: 'centros-custo',
  relationType: 'path',
  restApi,
  queryTransform: {
    ...paginate
  }
})

gestoresCentroCustoRepository.remove = async ({ id }) => {
  if (!id) throw new Error('ID é obrigatório para delete')
  const uri = `gestores-centro-custo/${id}`
  const response = await restApi.delete(uri)
  return {
    ok: response.ok,
    data: response.data
  }
}

gestoresCentroCustoRepository.getOne = ({ id }) => {
  return restApi.get(`gestores-centro-custo/${id}`)
}

export default gestoresCentroCustoRepository
